module.exports = __webpack_public_path__ + "img/icon-hailiang-logo-sz.31c76f9b.svg";